'use strict';

/*jshint unused: false*/
var colorReferenceFilesComponent = {
  restrict: 'E',
  replace: true,
  transclude: true,
  bindings: {
    colorReferences: '<',
    isPreviewVisible: '=',
    jobId: '='
  },
  controller: /*@ngInject*/ function(COLOR_REFERENCE, ReactNavigationService) {
    var _self = this;

    _self.imgHero = {
      active: false,
      src: '',
      name: '',
      type: ''
    };

    _self.showHero = function(cr) {
      _self.isPreviewVisible = true;
      _self.imgHero.active = true;
      _self.imgHero.src = `${cr.downloadUrl}`;
      _self.imgHero.name = cr.originalFileName;
      _self.imgHero.type = 'Color Reference';
    };

    _self.getCRTitle = function(cr) {
      return cr.type === COLOR_REFERENCE.TYPE.MANUAL
        ? cr.originalFileName
        : `Reference View ${cr.view}`;
    };

    _self.getCRType = function(cr) {
      if (cr.type === COLOR_REFERENCE.TYPE.MANUAL) {
        return cr.override
          ? COLOR_REFERENCE.TAG.REPLACED
          : COLOR_REFERENCE.TAG.UPLOADED;
      }

      return COLOR_REFERENCE.TAG.RECOMMENDED;
    };

    _self.showRatingIcon = function(cr) {
      return cr.type === COLOR_REFERENCE.TYPE.CALCULATED;
    };

    _self.clickManagmentButton = function() {
      ReactNavigationService.goToJobDetail(_self.jobId)
    };
  },
  templateUrl: 'templates/partials/ui/colorReferenceFiles.tpl.html'
};

module.exports = colorReferenceFilesComponent;
